import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@/lib/utils';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn('relative flex w-full touch-none items-center select-none', className)}
    {...props}
  >
    {/* Track gris claro, contraste con el verde */}
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-neutral-100 dark:bg-neutral-800">
      {/* Range siempre verde */}
      <SliderPrimitive.Range className="absolute h-full bg-green-700" />
    </SliderPrimitive.Track>

    {/* Thumb con borde verde y ring verde al focus */}
    <SliderPrimitive.Thumb className="block h-4 w-4 cursor-pointer rounded-full border border-green-700 bg-white shadow transition-colors focus-visible:ring-1 focus-visible:ring-green-700 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50" />
    <SliderPrimitive.Thumb className="block h-4 w-4 cursor-pointer rounded-full border border-green-700 bg-white shadow transition-colors focus-visible:ring-1 focus-visible:ring-green-700 focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
